import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const typeList = this.element.dataset.typelist;
    $("#linkCategory").on('select2:select', function (e) {
        let id = e.params.data.id;
        if(!id ){
            $("#articleSelect").addClass("d-none");
            $("#outsideLink").addClass("d-none");
            return;
        }
        if(id == 1){
            $("#articleSelect").removeClass("d-none");
            $("#outsideLink").addClass("d-none");
            return;
        }
        if(id == 2){
            $("#articleSelect").addClass("d-none");
            $("#outsideLink").removeClass("d-none");
            return;
        }
        $("#articleSelect").addClass("d-none");
        $("#outsideLink").removeClass("d-none");
        const data = JSON.parse(typeList).find(x => x.id == id);
        if($("#menuLink_zh").length > 0){
            $("#menuLink_zh").val(`/zh-TW${data.link}`);
            $("#menuLink_en").val(`/en${data.link}`);
        }else{
            $("#menuLink").val(`${data.link}`);
        }
        $('#main_menu_slug').val(data.slug);
       
    });
  }
}
